import type { MarketListingDTO } from "@ghostland/shared";

export interface MarketState {
  listings: MarketListingDTO[];
  myCount: number;
  maxListings: number;
}
type Listener = (s: MarketState) => void;

/** Client mirror of the marketplace snapshot, fed by the server's `Market` message. */
class MarketStore {
  private state: MarketState = { listings: [], myCount: 0, maxListings: 10 };
  private readonly listeners = new Set<Listener>();
  get(): MarketState { return this.state; }
  set(state: MarketState): void { this.state = state; for (const fn of this.listeners) fn(this.state); }
  subscribe(fn: Listener): () => void { this.listeners.add(fn); fn(this.state); return () => this.listeners.delete(fn); }
}

export const marketStore = new MarketStore();
